import { Input } from '@chakra-ui/react'
import { mdiMagnify } from '@mdi/js'
import Icon from '@mdi/react'

import { Box } from '@/components/ui/box'
import { InputGroup } from '@/components/ui/input-group'

const Search = ({
    searchWord,
    onSearch,
    placeholder,
}: {
    searchWord: string
    onSearch: (searchedString: string) => void
    placeholder: string
}) => {
    return (
        <InputGroup
            startElement={
                <Box pointerEvents="none">
                    <Icon path={mdiMagnify} size={1} style={{ paddingInline: 0 }} />
                </Box>
            }
            startElementProps={{ paddingInline: 1 }}
        >
            <Input
                variant="searchFile"
                type="text"
                placeholder={placeholder}
                border="1px solid"
                borderColor="surface.dark"
                value={searchWord}
                onChange={(e: { target: { value: string } }) => onSearch(e.target.value)}
            />
        </InputGroup>
    )
}

export default Search
